import React from 'react';
import PropTypes from 'prop-types';

const FooterComponent = (props) => {
    const year = new Date().getFullYear();
    const {companyName} = props;
    return(
        <div className="app-footer">
            <p>&copy; {year} {companyName}</p>
        </div>
    );
}

export default FooterComponent;

FooterComponent.propTypes = {
    companyName: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/Shared/FooterComponent.js